import React from 'react';
import { addMinutes } from 'date-fns';
import { styled } from 'styled-components';
import { startOfTvDay } from './tv-guide-types';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { centralEuropeanNow } from '../../../../play-core/utils/date-helper';
import { isoDate, shortTimeFormat } from '../../utils/date-formatter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const startOfDay = startOfTvDay(isoDate(centralEuropeanNow()));
export const TimelineMarker = ({
  minutes,
  left,
  top = 12
}) => /*#__PURE__*/_jsxs(Marker, {
  "aria-hidden": true,
  style: {
    left: `${left}px`,
    top: `${top}px`
  },
  children: [/*#__PURE__*/_jsx("span", {
    children: shortTimeFormat(addMinutes(startOfDay, minutes))
  }), /*#__PURE__*/_jsx(MarkerLine, {})]
});
const Marker = styled.div.withConfig({
  displayName: "TimelineMarker__Marker",
  componentId: "sc-16yyewr-0"
})(["position:absolute;display:flex;flex-direction:column;transform:translateX(-50%);", ";color:", ";"], Fonts.regular(14), Colors.WHITE);
const MarkerLine = styled.div.withConfig({
  displayName: "TimelineMarker__MarkerLine",
  componentId: "sc-16yyewr-1"
})(["width:1px;align-self:center;height:12px;margin-top:6px;background-color:", ";"], Colors.GREY_969696);